import { Component, Input, OnInit, Output, ViewChild, EventEmitter, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RuleSet } from 'ngx-angular-query-builder';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { UtilsService } from 'src/app/common/services/utils.service';
import { Event } from 'src/app/common/events/event-base';
import { SEOQueryBuilder } from '../../models/query-builder';
import { QueryBuilderProcessor } from '../../models/query-builder-processor';
import { NgxAngularQueryBuilderModule } from 'ngx-angular-query-builder';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'gig-advance-filter',
  standalone: true,
  imports: [CommonModule, FormsModule, OverlayPanelModule, NgxAngularQueryBuilderModule, ButtonModule, TranslateModule],
  templateUrl: './advance-filter.component.html',
  styleUrls: ['./advance-filter.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AdvanceFilterComponent implements OnInit {

  public advanceFilterMessage: string;
  public draftRuleset: RuleSet;
  private defaultRuleset: RuleSet;

  @ViewChild('af') af: OverlayPanel;

  @Input() ruleset: RuleSet;
  @Input() qbProcessor: QueryBuilderProcessor;
  @Input() qbConfig: SEOQueryBuilder;


  @Output() advanceFilterEvent: EventEmitter<AdvanceFilterEvent> = new EventEmitter<AdvanceFilterEvent>();


  public constructor(private utils: UtilsService) { }

  public ngOnInit(): void {
    this.utils.logger.info('AdvanceFilterComponent.ngOnInit()');
    this.defaultRuleset = JSON.parse(JSON.stringify(this.ruleset));

  }

  public onToggleAdvanceFilter(e: any): void {
    e.preventDefault();
    this.utils.logger.info('AdvanceFilterComponent.onToggleAdvanceFilter()');
    this.draftRuleset = this.cloneRuleset(this.ruleset);
    this.af.toggle(e);
  }

  public onClearAdvanceFilter(e: any): void {
    e.preventDefault();
    this.utils.logger.info('AdvanceFilterComponent.onClearAdvanceFilter()', JSON.stringify(this.defaultRuleset));
    this.advanceFilterMessage = '';
    this.ruleset = this.cloneRuleset(this.defaultRuleset);
    this.draftRuleset = this.cloneRuleset(this.defaultRuleset);
    this.advanceFilterEvent.emit(new AdvanceFilterEvent('AdvanceFilterEvent.UPDATE_RULESET', this.ruleset));

  }

  public onApplyAdvanceFilter(): void {
    this.ruleset = this.cloneRuleset(this.draftRuleset);
    if (this.qbProcessor.isAdvanceFilter(this.ruleset)) {
      this.advanceFilterMessage = this.qbProcessor.explainRules(this.ruleset.rules, this.ruleset.condition);
      this.advanceFilterEvent.emit(new AdvanceFilterEvent('AdvanceFilterEvent.UPDATE_RULESET', this.ruleset));
    } else {
      this.advanceFilterMessage = '';
    }
    this.af.hide();
  }

  public onCancelAdvanceFilter(): void {
    this.draftRuleset = this.cloneRuleset(this.ruleset);
    this.af.hide();
  }

  public get activeFilterCount(): number {
    return this.countRules(this.ruleset);
  }

  private cloneRuleset(ruleset: RuleSet): RuleSet {
    return JSON.parse(JSON.stringify(ruleset));
  }

  private countRules(ruleset: RuleSet): number {
    return (ruleset?.rules ?? []).reduce((count: number, rule: any) => {
      if (Array.isArray(rule.rules)) {
        return count + this.countRules(rule as RuleSet);
      }
      return count + (this.qbProcessor?.isAdvanceFilter(rule) ? 1 : 0);
    }, 0);
  }

}

export class AdvanceFilterEvent extends Event {
  constructor(type: string, payload: any) {
    super(type, payload);
  }
}
